import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ConstantsService {
	public backendUrl: string;
	public serverHttpOrHttps: string;
	public serverAddress: string;
	public serverPort: number;

	private userAuthority = new BehaviorSubject<number>(null);

	public beneficiaireUrl: string;
	public formationUrl: string;
	public employeeUrl: string;
	public buildSolutionUrl: string;
	public getSolutionUrl: string;
	public planningUrl: string;
	public routeUrl: string;
	public vacationTypeUrl: string;
	public evaluateUrl: string;

	public authUrl: string;
	public statisticsUrl: string;
	public activityReportEmployeeUrl: string;
	public activityReportBeneficiaireUrl: string;
	public funderReportUrl: string;

	public missionPlaceUrl: string;
	public specialiteUrl: string;
	public careSkillUrl: string;
	public typeFormationUrl: string;

	public userUrl: string;
	public roleUrl: string;
	public missionUrl: string;

	public vehiculeUrl: string;

	public paramPreferencesBeneficiaire: string;
	public paramVehicule: string;
	public messageUrl: string;
	public userConvUrl: string;
	public notificationsUrl: string;
	public messageNotificationUrl: string;

	public vacationUrl: string;

	public unavailabilityUrl: string;

	public centerUrl: string;
	public areaUrl: string;
	public missionTypeUrl: string;
	public funderUrl: string;

	public exportUrl: string;
	public availabilityUrl: string;
	public missionWithMultipleEmployeeUrl: string;

	public parcoursUrl: string;
	public prescriberUrl: string;
	public prescriberRequestUrl: string;

	public centerDepartmentUrl: string;
	public activityReportSAEByDateUrl: string;

	//OPTIM
	public optimUrl: string;
	constructor() {
		this.serverHttpOrHttps = environment.serverHttpOrHttps;
		this.serverAddress = environment.serverAddress;
		this.serverPort = environment.serverPort;
		this.backendUrl =
			this.serverHttpOrHttps +
			'://' +
			this.serverAddress +
			':' +
			this.serverPort +
			'/affectation';

		this.updateAllUrls();
	}

	updateAllUrls() {
		this.beneficiaireUrl = `${this.backendUrl}/beneficiaire`;
		this.formationUrl = `${this.backendUrl}/formation`;
		this.employeeUrl = `${this.backendUrl}/employee`;
		this.buildSolutionUrl = `${this.backendUrl}/build`;
		this.getSolutionUrl = `${this.backendUrl}/solution`;
		this.routeUrl = `${this.backendUrl}/route`;
		this.planningUrl = `${this.backendUrl}/planning`;
		this.evaluateUrl = `${this.backendUrl}/evaluate`;

		this.authUrl = `${this.backendUrl}/auth`;
		this.statisticsUrl = `${this.backendUrl}/statistique`;
		this.activityReportEmployeeUrl = `${this.backendUrl}/activityreport/employee`;
		this.activityReportBeneficiaireUrl = `${this.backendUrl}/activityreport/beneficiaire`;
		this.activityReportSAEByDateUrl = `${this.backendUrl}/activityreport/sae`;
		this.funderReportUrl = `${this.backendUrl}/funder/report`;

		this.missionPlaceUrl = `${this.backendUrl}/ecole`;
		this.vacationTypeUrl = `${this.backendUrl}/vacation_type`;
		this.careSkillUrl = `${this.backendUrl}/competence`;
		this.specialiteUrl = `${this.backendUrl}/specialite`;
		this.typeFormationUrl = `${this.backendUrl}/type_formation`;
		this.userUrl = `${this.backendUrl}/user`;

		this.userConvUrl = `${this.backendUrl}/messages/conversations`;

		this.roleUrl = `${this.backendUrl}/role`;
		this.missionUrl = `${this.backendUrl}/mission`;
		this.vehiculeUrl = `${this.backendUrl}/vehicle`;
		this.paramPreferencesBeneficiaire = `${this.backendUrl}/parametre/preferences/beneficiaire`;
		this.paramVehicule = `${this.backendUrl}/parametre/vehicule`;
		this.messageUrl = `${this.backendUrl}/messages`;
		this.notificationsUrl = `${this.backendUrl}/notifications`;
		this.messageNotificationUrl = `${this.backendUrl}/messagerie/notifications`;
		this.vacationUrl = `${this.backendUrl}/vacation`;
		this.unavailabilityUrl = `${this.backendUrl}/unavailability`;
		this.centerUrl = `${this.backendUrl}/center`;
		this.areaUrl = `${this.backendUrl}/area`;
		this.missionTypeUrl = `${this.backendUrl}/mission/type`;
		this.funderUrl = `${this.backendUrl}/funder`;

		this.optimUrl = `${this.backendUrl}/optim`;
		this.exportUrl = `${this.backendUrl}/export`;
		this.availabilityUrl = `${this.backendUrl}/availability`;
		this.missionWithMultipleEmployeeUrl = `${this.backendUrl}/event/group`;

		this.parcoursUrl = `${this.backendUrl}/parcours`;
		this.prescriberUrl = `${this.backendUrl}/prescriber`;
		this.prescriberRequestUrl = `${this.backendUrl}/prescriberRequest`;

		this.centerDepartmentUrl = `${this.backendUrl}/department`;
	}

	updateUserAuthority(authority: number) {
		this.userAuthority.next(authority);
	}

	public getUserAuthorityObservable(): Observable<number> {
		return this.userAuthority.asObservable();
	}
}

export const BASE_NOMINATIM_URL = 'nominatim.openstreetmap.org';
export const DEFAULT_VIEW_BOX =
	'viewbox=-25.0000%2C70.0000%2C50.0000%2C40.0000';
export const API_ADRESSE_DATA_GOUV = 'api-adresse.data.gouv.fr';

// CENTER PARAMETERS
export const PARAM_PREFERENCES_BENEFICIAIRE = 'preferences_beneficiaire';
export const PARAM_VEHICULE = 'vehicule_mode';

export const PARAM_VEHICULE_VALUE_OFF = 'OFF';
export const PARAM_VEHICULE_VALUE_AUTO = 'AUTO';

export const PARAM_HOMECARE = 'home_care';
export const PARAM_IS_AVAILABILITY_PLANNING_VISIBLE =
	'availability_planning_visible';

export const PARAM_OPTIM_PARAMS_EDITABLE = 'optim_params_editable';

export const PARAM_LABEL_INTERVENANT = 'label_intervenant';
export const PARAM_LABEL_BENEFICIAIRE = 'label_beneficiaire';
export const PARAM_LABEL_INTERVENTION = 'label_intervention';

export const PARAM_LABEL_HOUR_MIN_DAY = 'hour_min_day'; // hours
export const PARAM_LABEL_HOUR_MAX_DAY = 'hour_max_day'; // hours
export const FORMATION_DURATION_MAX = 900; // 900 minutes = 15H

export const MISSION_TYPE_REUNION_TYPE = 'Réunion';
export const MISSION_TYPE_QUALIFICATION_DEMAND = 'QD';
export const MISSION_TYPE_PRESCRIPTION = 'Prescription';

export const OPTIM_QUEUE = 'optim_queue';

export const AREA_ACTIVE = 'area_active';
export const OPTIM_MULTIPLE = 'optim_multiple';

export const THEME_COLOR_MAIN = '#262c5e';
export const THEME_COLOR_BLUE = '#668bc7';
export const THEME_COLOR_RED = '#ed7387';
export const THEME_COLOR_GREEN = '#8dcdcb';
export const THEME_COLOR_PINK = '#f19eaf';
export const THEME_COLOR_VIOLET = '#a3acd8';

export const PARAM_MAX_ANNULATION_TARDIVE_IN_HOURS =
	'max_annulation_tardive_in_hours';

export const PARAM_FUNDER_ACTIVE = 'funder_active';

export const CACHE_LIFETIME = 3; // minutes
